import { render, staticRenderFns } from "./UptimeKuma.vue?vue&type=template&id=5762d847&scoped=true&"
import script from "./UptimeKuma.vue?vue&type=script&lang=js&"
export * from "./UptimeKuma.vue?vue&type=script&lang=js&"
import style0 from "./UptimeKuma.vue?vue&type=style&index=0&id=5762d847&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5762d847",
  null
  
)

export default component.exports